import React, { useEffect, useRef } from "react";
import { useState } from "react";
import planningService from "@services/planning.service";
import indexService from "@services/index.service";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { ProgressBar } from "primereact/progressbar";
import { BlockUI } from "primereact/blockui";
import { useSocket } from "@components/SocketProvider";
import { filesize } from "filesize";
import { TabView, TabPanel } from "primereact/tabview";

const Import = () => {
  const [files, setFiles] = useState([]);
  const [update, setUpdate] = useState(false);
  const fileUploadRef = useRef(null);
  const toast = useRef(null);
  const [totalSize, setTotalSize] = useState(0);
  const [blocked, setBlocked] = useState(false);
  const socket = useSocket();
  const [activeIndex, setActiveIndex] = useState(0);

  function fetchData() {
    planningService
      .Get("/fileList")
      .then((result) => {
        setFiles(result.data);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: "Error happend",
        });
      });
  }
  useEffect(() => {
    fetchData();
    const id = setInterval(fetchData, 10000);
    return () => clearInterval(id);
  }, [update]);

  useEffect(() => {
    socket.on("fileParsingError", function (data) {
      console.log("fileParsingError");
      toast.current.show({
        severity: "error",
        summary: "error",
        life: 10000,
        detail: data.name + " face error.",
      });
      // setUpdate(!update);
    });
    socket.on("fileParsingParsed", function (data) {
      console.log("fileParsingParsed");
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: data.name + " parsed.",
      });
      // setUpdate(!update);
    });
    socket.on("fileParsingStart", function (data) {
      console.log("fileParsingStart");
      toast.current.show({
        severity: "info",
        summary: "Info",
        detail: data.name + " start parsing.",
      });
    });
  }, [socket]);
  const onTemplateRemove = (file, callback) => {
    setTotalSize(totalSize - file.size);
    callback();
  };
  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn  p-button-outlined",
  };
  const uploadOptions = {
    icon: "pi pi-fw pi-cloud-upload",
    iconOnly: true,
    className: "custom-upload-btn p-button-success  p-button-outlined",
  };
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className: "custom-cancel-btn p-button-danger  p-button-outlined",
  };

  const onUpload = async (event) => {
    try {
      // console.log("file", fileList.map(f => f.originFileObj));
      // console.log("values", { ...values });
      setBlocked(true);
      const formData = new FormData();
      // console.log(event.files);
      let index = 0;
      for (let file of event.files) {
        formData.append("crAttach" + index, file);
        index++;
        let i = 0;
        // const response = await fetch("/api/get-presigned-url?fileName=" + file.name);
        let data = await indexService.Get("get-presigned-url?fileName=" + file.name);
        // console.log(data.data.url);
        if (data.data.url) {
          const uploadResponse = await fetch(data.data.url, {
            method: "PUT",
            body: file,
            headers: {
              "Content-Type": file.type,
            },
          });
          console.log(uploadResponse);
          if (uploadResponse.ok) {
            await planningService.Post("/importFromCloudflare", { fileName: file.name });

            toast.current.show({
              severity: "info",
              summary: "info",
              detail: "Upload to cloud done",
            });
          }
          else {
            toast.current.show({
              severity: "error",
              summary: "error",
              life: 10000,
              detail: " Upload to cloud failed ",
            });
          };
        }

      }
      // await planningService.PostForm("/import", formData);
      setUpdate(!update);
      setActiveIndex(0);
      // fileUploadRef.current.clear();
      toast.current.show({
        severity: "info",
        summary: "info",
        detail: "Upload Done",
      });
      // console.log(res);
      // setFileLink(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      // setSubmitted(false);
      setBlocked(false);
    }
  };
  const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 7000000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : "0 B";

    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}
        {uploadButton}
        {cancelButton}
        <a
          href="https://mega.nz/filerequest/skoVzpOav94"
          target="_blank"
          rel="noopener noreferrer"
          className="p-button font-bold"
        >
          MEGA
        </a>
        <div className="flex align-items-center gap-3 ml-auto">
          <span>{formatedValue} / 700 MB</span>
          <ProgressBar
            value={value}
            showValue={false}
            style={{ width: "10rem", height: "12px" }}
          ></ProgressBar>
        </div>
      </div>
    );
  };
  const onTemplateSelect = (e) => {
    let _totalSize = totalSize;
    let files = e.files;

    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0;
    });

    setTotalSize(_totalSize);
  };

  const onTemplateUpload = (e) => {
    let _totalSize = 0;

    e.files.forEach((file) => {
      _totalSize += file.size || 0;
    });

    setTotalSize(_totalSize);
    toast.current.show({
      severity: "info",
      summary: "Success",
      detail: "File Uploaded",
    });
  };
  const itemTemplate = (file, props) => {
    return (
      <div className="flex align-items-center flex-wrap">
        <div className="flex align-items-center" style={{ width: "40%" }}>
          <span className="flex flex-column text-left ml-3">
            {file.name}
            {/* <small>{new Date().toLocaleDateString()}</small> */}
          </span>
        </div>
        <Tag
          value={props.formatSize}
          severity="warning"
          className="px-3 py-2"
        />
        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };
  const onTemplateClear = () => {
    setTotalSize(0);
  };
  const dateBodyTemplate = (row, column) => {
    let columnName = column.column.props.header;

    return new Date(row[columnName]).toLocaleString();
  };
  const fileSizeTemplate = (row, column) => {
    let columnName = column.column.props.header;

    return filesize(row[columnName], { standard: "jedec" });
  };
  const boolBodyTemplate = (row, column) => {
    if (row.parsing) {
      return <i className="pi pi-spin pi-cog"></i>;
    } else if (row.parsed) {
      return <i className="pi pi-check" style={{ color: "green" }}></i>;
    } else if (row.hasError) {
      return <i className="pi pi-times" style={{ color: "red" }}></i>;
    } else {
      return <i className="pi pi-spin pi-spinner"></i>;
    }
  };
  return (
    <>
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel
          leftIcon="pi pi-list mr-2"
          className="mr-2 ml-2"
          header="List"
        >
          <DataTable value={files} paginator rows={15}>
            <Column field="name" header="name"></Column>
            <Column field="user" header="user"></Column>
            <Column field="size" body={fileSizeTemplate} header="size"></Column>
            <Column
              field="importDate"
              body={dateBodyTemplate}
              header="importDate"
            ></Column>
            <Column body={boolBodyTemplate} header="State"></Column>
            <Column field="error" header="error"></Column>
            <Column field="totalDocs" header="totalDocs"></Column>
          </DataTable>
        </TabPanel>
        <TabPanel
          leftIcon="pi pi-cloud-upload mr-2"
          className="mr-2 ml-2"
          header="Upload"
        >
          <BlockUI blocked={blocked}>
            <FileUpload
              headerTemplate={headerTemplate}
              itemTemplate={itemTemplate}
              multiple={true}
              ref={fileUploadRef}
              name="attachments"
              onValidationFail={(e) =>
                toast.current.show({
                  severity: "error",
                  summary: "error",
                  detail: "MAX Filesize is 700 MB",
                })
              }
              customUpload
              uploadHandler={onUpload}
              maxFileSize={700000000}
              onError={onTemplateClear}
              chooseOptions={chooseOptions}
              uploadOptions={uploadOptions}
              cancelOptions={cancelOptions}
              onUpload={onTemplateUpload}
              onSelect={onTemplateSelect}
              onClear={onTemplateClear}
              emptyTemplate={
                <p className="m-0">Drag and drop files to here to upload.</p>
              }
            />
          </BlockUI>
        </TabPanel>

        {/* <TabPanel leftIcon="pi pi-info-circle mr-2"
          className="mr-2 ml-2" header="Help">
          <p className="m-0">
           
          </p>
        </TabPanel> */}
      </TabView>
      <Toast ref={toast} />
    </>
  );
};

export default Import;
